import React, { useState } from 'react';

import { Form, Row, Col, Modal } from 'react-bootstrap';

import { ApiServiceServerless } from '../../xhr_libs';
import AddEntityActionButtons from '../forms/AddEntityActionButtons';

export default function AddRegressionEventCollectionModal(props) {
  const {
    show,
    onHide,
    showToast,
    organization_id,
    addToList,
    setActiveCollectionId,
    setRegressionEventCollectionsEditted,
  } = props;

  const [name, setName] = useState(null);

  const [isLoading, setIsLoading] = useState(false);

  const saveRegressionEventCollection = () => {
    setIsLoading(true);
    ApiServiceServerless.post(
      `/regression_events/collection`,
      {
        name: name,
        org_id: organization_id,
      },
      { authorization_id: organization_id }
    )
      .then((res) => {
        showToast(
          'success',
          'Success',
          'New  Regression Event Collection Created'
        );
        addToList(res.data, 'regression_event_collections');
        setRegressionEventCollectionsEditted((prev) => prev + 1);
        setActiveCollectionId(res.data.id);
      })
      .catch(() => {
        showToast('danger', 'Error', 'Creation Error');
      })
      .finally(() => {
        onHide();
        setIsLoading(false);
      });
  };

  const saveDisabled = name === null;

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <div as='h5'>Create a Regression Event Collection</div>
      </Modal.Header>

      <Modal.Body>
        <Row>
          <Col sm={12}>
            <Form.Group>
              <Form.Label>
                Name
                <span className='text-warning font-weight-bold pl-1'>*</span>
              </Form.Label>
              <Form.Control
                required
                placeholder=''
                onChange={(e) => setName(e.target.value)}
              />
            </Form.Group>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <AddEntityActionButtons
          onCancel={onHide}
          onSubmit={saveRegressionEventCollection}
          submitDisabled={saveDisabled}
          isSubmitting={isLoading}
        />
      </Modal.Footer>
    </Modal>
  );
}
